"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TruncatedTextWithTooltip = void 0;
var React = _interopRequireWildcard(require("react"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _useWindowSize = require("../../hooks/useWindowSize");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _ConditionalWrapper = require("../ConditionalWrapper");
var _Tooltip = require("../Tooltip");
var _TruncatedTextWithTooltipModule = _interopRequireDefault(require("./TruncatedTextWithTooltip.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const TruncatedTextWithTooltip = _ref => {
  let {
    classNames,
    children,
    tooltip,
    wrapText = false,
    line = 1,
    wordBreak = 'break-all',
    // @ts-ignore - TS6133 - 'props' is declared but its value is never read.
    ...props
  } = _ref;
  const {
    width
  } = (0, _useWindowSize.useWindowSize)();
  const [showMouseTip, setShowMouseTip] = React.useState(false);
  // @ts-ignore - TS2554 - Expected 1 arguments, but got 0.
  const truncatedRef = React.useRef();
  const checkIfTextOverflowing = React.useMemo(() => (0, _debounce.default)(() => {
    if (!wrapText && truncatedRef && truncatedRef.current && truncatedRef.current.scrollHeight > truncatedRef.current.clientHeight) {
      setShowMouseTip(true);
    } else {
      setShowMouseTip(false);
    }
  }, 200, {
    leading: true
  }), []);
  React.useEffect(() => {
    checkIfTextOverflowing();
  }, [width, line, children, wrapText]);
  const styles = {
    '--line-clamp': wrapText ? 'unset' : line,
    '--word-break': wordBreak
  };
  return /*#__PURE__*/React.createElement(_ConditionalWrapper.ConditionalWrapper, {
    condition: Boolean(showMouseTip),
    wrapper: children => {
      const child = React.Children.only(children);

      //Vivek: This children in tooltip body is modified to remove line clamp style
      // @ts-ignore - TS2769 - No overload matches this call.
      const modifiedChild = /*#__PURE__*/React.cloneElement(child, {
        style: {
          '--line-clamp': tooltip?.bodyMaxLines || line,
          '--word-break': wordBreak
        }
      });
      return /*#__PURE__*/React.createElement(_Tooltip.Tooltip, _extends({}, tooltip, {
        body: tooltip?.body || modifiedChild,
        elevation: tooltip?.elevation ?? 'toast'
      }), /*#__PURE__*/React.createElement("div", {
        className: _TruncatedTextWithTooltipModule.default.childrenWrapper
      }, children));
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: (0, _classify.default)(_TruncatedTextWithTooltipModule.default.truncateLineClamp, classNames?.wrapper),
    style: styles
    // @ts-ignore - TS2322 - Type 'RefObject<HTMLSpanElement | null | undefined>' is not assignable to type 'Ref<HTMLSpanElement> | undefined'.
    ,
    ref: truncatedRef
  }, children));
};
exports.TruncatedTextWithTooltip = TruncatedTextWithTooltip;